import { render, staticRenderFns } from "./StepDatamodelModal.vue?vue&type=template&id=6816dd66&scoped=true&"
import script from "./StepDatamodelModal.vue?vue&type=script&lang=ts&"
export * from "./StepDatamodelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6816dd66",
  null
  
)

export default component.exports